import React from "react";
import classNames from "classnames";
import {
  SidebarGlobalSettingsSvg,
  SidebarHomeSvg,
  SidebarMasterUsersSvg,
  SidebarMobileAppSvg,
  SidebarStaffSvg,
} from "../../icons";
import { useLocation, useParams, useNavigate } from "react-router";
import { IAccessPages, IRoute } from "../../utils/types";
import useGetHotelConfig from "../../hooks/use-get-hotel-config";

const SIDEBAR_ICONS: Record<string, React.FC> = {
  "tv-app": SidebarHomeSvg,
  "mobile-app": SidebarMobileAppSvg,
  "master-users": SidebarMasterUsersSvg,
  "staff": SidebarStaffSvg,
  "global-setting": SidebarGlobalSettingsSvg,
};

interface SidebarProps {
  routes: IRoute[];
  accesspages: IAccessPages[];
}

const Sidebar: React.FC<SidebarProps> = ({ routes, accesspages }) => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const { data: hotelConfig } = useGetHotelConfig();

  const SIDEBAR_ITEMS = accesspages.map((item) => {
    const findRoutes = routes.find((route) => route.value === item.name);
    if (!findRoutes) {
      return;
    }
    return {
      title: findRoutes.name,
      icon: SIDEBAR_ICONS[findRoutes.value],
      badge: findRoutes.value === "tv-app",
      active: false,
      path: findRoutes.path,
    };
  });

  return (
    <div
      className="fixed h-full w-[280px] p-4 bg-white shadow-[0px_0px_21px_0px_#59667A1A] ease-in-out transition-all"
      id="sidebar"
    >
      <img className="h-7" src={hotelConfig?.hotelLogoBlack} alt={hotelConfig?.hotelCode} />
      <div className="mt-7.5">
        {SIDEBAR_ITEMS?.map((item) =>
          item ? (
            <div
              key={item.path}
              onClick={() => navigate(`/${params.hotelcode}${item.path}`)}
              className={classNames(
                "flex items-center justify-between pl-[15px] pr-[30px] py-3 rounded-[10px] cursor-pointer hover:bg-[#F4F6FF] hover:text-[#F41095]",
                location.pathname.includes(
                  `/${params.hotelcode}${item.path}`
                ) || location.pathname === `/${params.hotelcode}${item.path}`
                  ? "bg-[#F4F6FF] text-[#F41095]"
                  : ""
              )}
            >
              <div className="flex items-center gap-[5px]">
                <item.icon />
                <span>{item.title}</span>
              </div>
              {item.badge && (
                <div className="px-2 py-1 bg-[#6362E71A] rounded-[10px] text-[10px] leading-[10px] font-normal tracking-[0.7px] text-[#6362E7]">
                  2
                </div>
              )}
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

export default Sidebar;
